const Modal = (target) => {
  const closeBtn = target.querySelector(".modal__close");
  const iframe = target.querySelector("iframe");

  const method = {
    init: () => {
      closeBtn.addEventListener("click", method.close);
      target.addEventListener("click", method.onClick);
    },

    onClick: (e) => {
      e.stopPropagation();

      if (!iframe.contains(e.target)) {
        method.close();
      }
    },

    close: () => {
      iframe.src = "";
      target.classList.remove("modal--open");
    },
  };

  method.init();
};

export default Modal;
